export default "__VITE_ASSET__4c1324d3__"